import {defineStore} from "pinia";
import axios from "axios";

export const orgProfileStore = defineStore('orgProfileStore',{
    state: () => ({
        orgProfileInfo: null
    }),
    actions: {
        getOrgProfileInfo(id) {
            return axios.get(`/api/org/profile/${id}`).then((resp)=> {
                this.orgProfileInfo = resp.data;
            });
        },
        getOrgProfileNews(params) {
            return axios.get(`/api/org/profile/${params.id}/news`,{
                params: params
            });
        }
    }
});